import {BaseApplet} from "../BaseApplet";
import React from "react";
import {StyledEmpty} from "../../../shared/StyledComponents";
import {NotificationsOutlined} from "@mui/icons-material";

export class NotificationsApplet extends BaseApplet {
  protected renderApplet(): React.ReactElement {
    return <StyledEmpty emptyConfig={{
      title: "No new notifications",
      text: "You are all caught up!",
      iconType: NotificationsOutlined,
    }}/>;
  }
}